import { useContext } from 'react';
import { ACTIVITY_TYPES } from '../../state/state.utils';
import { StyledHeader } from './ScatterChart.style';
import { SCATTER_POINTS_LIMIT } from './useFetchData/usePayload';
import MetricsInspectionContext from '../../state/context';
import TopLimitAlert from './TopLimitAlert';
import { mapMetricNameToYAxisMetric } from './useFetchData/entities.utils';
import { metricNames } from '@linearb/linjs-common';

const mapActivityTypeToEntitiyName = {
  [ACTIVITY_TYPES.BRANCHES]: 'Branches',
  [ACTIVITY_TYPES.PRS]: 'PRs'
};

const OVERRIDE_TITLE_PER_METRIC = {
  [metricNames.REVIEW_DEPTH]: 'Total comments per PRs'
};

export const getTotalEntitiesStr = total => {
  const isPaginated = total >= SCATTER_POINTS_LIMIT;
  const topStr = isPaginated ? 'Top' : '';
  return `${topStr} ${total}`;
};

const getTitle = (metricName, activityType) => {
  if (OVERRIDE_TITLE_PER_METRIC[metricName]) {
    return OVERRIDE_TITLE_PER_METRIC[metricName];
  }

  const entitiyName = mapActivityTypeToEntitiyName[activityType] || '';
  const perYAxisMetric = mapMetricNameToYAxisMetric[metricName];
  return [
    entitiyName,
    'distribution',
    ...(perYAxisMetric ? [`per ${perYAxisMetric}`] : [])
  ].join(' ');
};

const Header = ({ data }) => {
  const {
    state: {
      metricName,
      filters: { activityType }
    }
  } = useContext(MetricsInspectionContext);

  const totalEntitiesStr = getTotalEntitiesStr(data?.length);

  const isPaginated = data?.length >= SCATTER_POINTS_LIMIT;

  return (
    <StyledHeader>
      <main>{totalEntitiesStr}</main>
      <section>{getTitle(metricName, activityType)}</section>
      {isPaginated && <TopLimitAlert />}
    </StyledHeader>
  );
};

export default Header;
